export const formatDaysValidity = (days: number[]): string => {
  const dayLabels = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];

  return days
    .sort((a, b) => a - b) // optional: ensure correct order
    .map((day) => dayLabels[day - 1])
    .join(", ");
};
